import CardDiv from "modules/common/card-div/CardDiv";
import { fourPlaceHolder, isDownloadDisabled } from "modules/utilities/utility";
import React, { useContext, useEffect } from "react";
import { Button, Tooltip } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { isEmpty } from "lodash";
import NoData from "assets/svgs/no_data/NoData";
import moment from "moment";
import { Link } from "react-router-dom";
import xlsx from "json-as-xlsx";
import { FeedbackDate } from "./FeedbackTab";
import { useTreatmentFeedback } from "./store";

function TreatmentFeedbackTable({ treatmentFeedback, isLoading }) {

  const { startDate, endDate } = useContext(FeedbackDate);
  const {treatmentDownloadData, treatmentDownloadLoading, fetchTreatmentFeedbackDownload} = useTreatmentFeedback();

  useEffect(()=>{
    fetchTreatmentFeedbackDownload(startDate.valueOf(), endDate.valueOf());
  },[startDate])


  const ExcelDownload = (excelData) => {
    const _data = excelData?.map((el) => {
      return {
        ...el,
        userName: el.user ? el.user?.first_name : "",
        userPhoneNumber: el.user ? el.user?.phone_number : "",
        userGender: el.user ? el.user?.gender : "",
        userEmail: el.user ? el.user?.email : "",
        resultWithTraya: el.results?el?.results:"",
        tellUsMore:el.tell_us_more?el?.tell_us_more:"",
        updatedAt: moment(el.updatedAt).format("DD-MM-YYYY HH:mm:ss"),
        createdAt: moment(el.createdAt).format("DD-MM-YYYY HH:mm:ss"),
      };
    });
    const data = [
      {
        sheet: "deliveryFeedbacks",
        columns: [
          { label: "Case Id", value: "case_id" },
          { label: "Customer Name", value: "userName" },
          { label: "Customer Phone Number", value: "userPhoneNumber" },
          { label: "Customer Email Id", value: "userEmail" },
          { label: "Customer Gender", value: "userGender" },
          { label: "Result With Traya", value: "resultWithTraya" },
          { label: "Tell Us More", value: "tellUsMore" },
          {
            label: "Created At",
            value: "createdAt",
          },
          {
            label: "Updated At",
            value: "updatedAt",
          },
        ],
        content: _data,
      },
    ];

    let settings = {
      fileName: `Delivery Feedbacks`,
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };
    xlsx(data, settings);
  };

  return (
    <div>
      <div className="mt-2">
        <CardDiv
          title={
            <div className="d-flex justify-content-between my-n2">
              <div className="fs-2">CSAT Feedback</div>
              <div>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                    onClick={() => ExcelDownload(treatmentDownloadData?.feedbacks)}
                  disabled={isEmpty(treatmentDownloadData?.feedbacks)}
                >
                  Download
                </Button>
              </div>
            </div>
          }
          component={
            <div className="mt-1 shadow">
              <div className="d-flex border rounded-top table-head">
                <span className="p-3 fw-bold text-black flex-1">
                  Customer Name
                </span>
                <span className="p-3 fw-bold text-black flex-1">Type</span>
                <span className="p-3 fw-bold text-black flex-1">Results</span>
                <Tooltip placement="top" title="Reason for Non Completion">
                  <span className="p-3 fw-bold cursor-pointer text-black flex-1 text-truncate">
                    Reason for Non Completion
                  </span>
                </Tooltip>
                <span className="p-3 fw-bold text-black flex-1">
                  Result Description
                </span>
                <span className="p-3 fw-bold text-black flex-1">
                  Tell Us More
                </span>
                <span className="p-3 fw-bold text-black flex-1">
                  Created At
                </span>
              </div>
              {isLoading ? (
                fourPlaceHolder()
              ) : treatmentFeedback?.length ? (
                treatmentFeedback?.map((order, index) => {
                  let strData = "";
                  let tellData = "";
                  order?.result_description?.forEach((item, index) => {
                    strData += item;
                  });
                  order?.tell_us_more?.forEach((item) => {
                    tellData += item;
                  });
                  return (
                    <div
                      className={`d-flex table-row border border-top-0 ${
                        index === order?.length - 1 && "rounded-bottom"
                      }`}
                    >
                      <span className="flex-1 d-flex flex-column gap-1 p-2 fw-bold">
                        <Link to={`/lead-details/${order?.user?.caseId}`}>
                          <div className="fw-bold text-primary">
                            {" "}
                            {order?.user?.first_name}
                          </div>
                        </Link>
                        {/* <span></span> */}
                      </span>
                      <span className="flex-1 text-black p-2">
                        {order?.url}
                      </span>
                      <span className="flex-1 text-black p-2">
                        {order?.results}
                      </span>
                      <span className="flex-1 text-black p-2 text-truncate">
                        {order.reason_for_not_completing}
                      </span>
                      <Tooltip placement="top" title={strData}>
                        <span className="flex-1 text-black d-flex flex-column cursor-pointer p-2 text-truncate">
                          {strData}
                        </span>
                      </Tooltip>
                      <Tooltip placement="top" title={tellData}>
                        <span className="flex-1 text-black p-2 cursor-pointer">
                          {tellData}
                        </span>
                      </Tooltip>
                      <span className="flex-1 text-black p-2">
                        {moment(order.createdAt).format("DD/MM/YY HH:mm:ss")}
                      </span>
                    </div>
                  );
                })
              ) : (
                <div className="p-3 rounded-bottom bg-white text-center">
                  No Data Available <NoData />
                </div>
              )}
            </div>
          }
        />
      </div>
    </div>
  );
}

export default TreatmentFeedbackTable;
